import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import {
  WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_ID,
  WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_KEY,
} from 'common/webmergeConstants';
import { formatPercentage } from 'common/formatters';
import { getListingFullAddressString } from 'common/listingHelpers';

import useBranch from 'client/hooks/useBranch';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrButton, {
  SR_BUTTON_HEIGHT_MEDIUM,
  SR_BUTTON_THEME_ADOBE_BLUE_INVERTED,
  SR_BUTTON_FONT_SIZE_SMALL,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';

const SrListingAgreement = ({ formikBag, formFields }) => {
  const { appUrl } = useBranch({
    appUrl: ['env', 'APP_URL'],
  });

  const {
    landlordName,
    landlordPhone,
    landlordEmail,
    commissionPercentClientPays,
  } = formikBag.values;

  const nowDateFormatted = momentWithAustinTimezone().format('YYYY-MM-DD');
  const listingLeaseAgreementWebmergePdfFields = {
    address: getListingFullAddressString(formikBag.values),
    landlordName: landlordName,
    landlordEmail: landlordEmail,
    landlordPhone: landlordPhone,
    commission: formatPercentage(commissionPercentClientPays),
    landlordNameBottom: landlordName,
    signedDateLandlord: nowDateFormatted,
    signedDateBroker: nowDateFormatted,
    termBegins: nowDateFormatted,
  };

  const leaseAgreementPdfUrl = url.resolve(
    appUrl,
    `/webmerge-pdf-viewer?documentId=${WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_ID}` +
      `&documentKey=${WEBMERGE_DOCUMENT_LANDLORD_LISTING_AGREEMENT_KEY}` +
      `&documentFields=${encodeURIComponent(
        JSON.stringify(listingLeaseAgreementWebmergePdfFields),
      )}`,
  );

  return (
    <SrCard padding="20px 20px 22px 20px">
      <SrButton
        heightType={SR_BUTTON_HEIGHT_MEDIUM}
        iconUrl="/images/terms-of-service-icon.svg"
        theme={SR_BUTTON_THEME_ADOBE_BLUE_INVERTED}
        fontSizeType={SR_BUTTON_FONT_SIZE_SMALL}
        onClick={() => {
          global.open(leaseAgreementPdfUrl, '_blank');
        }}
      >
        View Terms of Service
      </SrButton>
      {formFields.map((formField) => (
        <SrBox key={formField.id}>
          <SrFormikField formField={formField} formikBag={formikBag} theme={SR_FIELD_THEME_ADOBE} />
        </SrBox>
      ))}
    </SrCard>
  );
};

SrListingAgreement.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrListingAgreement.displayName = 'SrListingAgreement';

export default SrListingAgreement;
